export default __webpack_public_path__ + "static/mean-stack-development-company-peerbits-c971a45b1f4f5e0701b3b8db0daa4615.png";